var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'control-bar': true,
  'is-collapsable': _vm.collapsable
}},[(_vm.$slots.primary)?_c('div',{staticClass:"primary"},[_vm._t("primary")],2):_vm._e(),(_vm.$slots.secondary)?_c('div',{staticClass:"secondary"},[_vm._t("secondary")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }